<template>
    <div class="migrol-pager" v-if="totalPages > 1">
        <button v-if="currentPage > 1" type="button" @click="goTo(currentPage-1)" class="migrol-pager__page migrol-pager__page--non-button" rel="nofollow">
            <svg class="svg-inline--fa fa-chevron-left fa-w-10" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg=""><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>
        </button>
        
        <button type="button" @click="goTo(1)" :class="{ 'migrol-pager__page': true, 'migrol-pager__page--current': currentPage == 1 }" rel="nofollow">1</button>
        
        <span class="migrol-pager__page migrol-pager__page--non-button" v-if="showEllipsisBefore">&hellip;</span>
        
        <button type="button" @click="goTo(page)" :class="{ 'migrol-pager__page': true, 'migrol-pager__page--current': currentPage == page }" rel="nofollow" v-for="page in pages" :key="page">{{page}}</button>
        
        <span class="migrol-pager__page migrol-pager__page--non-button" v-if="showEllipsisAfter">&hellip;</span>
        
        <button type="button" @click="goTo(totalPages)" :class="{ 'migrol-pager__page': true, 'migrol-pager__page--current': currentPage == totalPages }" rel="nofollow">{{totalPages}}</button>

        <button v-if="currentPage < totalPages" type="button" @click="goTo(currentPage+1)" class="migrol-pager__page migrol-pager__page--non-button" rel="nofollow">
            <svg class="svg-inline--fa fa-chevron-right fa-w-10" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg=""><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            currentPage: {
                type: Number,
                required: true,
                default: 1
            },
            totalPages: {
                type: Number,
                required: true
            }
        },
        computed: {
            pages() {
                let dyn = [];
                for (var i = 2; i <= this.totalPages - 1; i++) {
                    if (i == this.currentPage - 1 || i == this.currentPage || i == this.currentPage + 1) {
                        dyn.push(i);
                    }
                }
                return dyn;
            },
            showEllipsisBefore() {
                return this.currentPage > 3;
            },
            showEllipsisAfter() {
                return this.currentPage < this.totalPages - 2;
            }
        },
        methods: {
            goTo(page) {
                this.$emit('pageChanged', page);
            }
        }
    };
</script>